import { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faTrash, faSave, faCancel, faBedPulse } from '@fortawesome/free-solid-svg-icons';
import { Field, Form, Formik, FieldArray, FormikErrors } from 'formik';
import FormErrorContainer from '../sections/shared/FormErrorContainer';
import { addTemplateTypeValidation } from '../../utiles/formValidation';
import useUtils from '../../utiles/useUtiles';
import { CircularProgress } from '@mui/material';

interface Props {
    show: boolean,
    handleClose: () => void
}
const ModalAddTemplateType: React.FC<Props> = ({ show, handleClose }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const { axiosRequest, baseUrl, toastInstance } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    const handleSubmit = async (values: any) => {
        setLoading(true);
        const request = await axios.post(`${baseUrl()}/template_types`, values);
        const { error, message, result } = request.data;
        setLoading(false);
        if (error) {
            toast.error(message);
        } else {
            toast.success(message);
            handleClose();
        }
    };

    const addColumn = (push: Function) => {
        push({
            name: '',
            columnType: "1"
        })
    }
    const removeColumn = (remove: Function, index: number) => {
        remove(index)
    }

    return (
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
            <Formik
                initialValues={{
                    name: '',
                    status: "1",
                    columns: [{
                        name: '',
                        columnType: "1"
                    }]
                }}
                validateOnChange={true}
                validateOnBlur={true}
                validationSchema={addTemplateTypeValidation}
                onSubmit={async (values, helpers) => {
                    // console.log('values: ', values)
                    handleSubmit(values);
                }}>
                {({ errors, values, handleChange }: { errors: any, values: any, handleChange: any }) => (
                    <Form>
                        <Modal.Header>
                            <Modal.Title>Add Template Type</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="cardCustom p-3">
                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                <label htmlFor="name">Name<strong className='text-danger'>*</strong></label>
                                                <Field data-cy="inputName" name="name" className="form-control" placeholder="Name" autoComplete={"new-password"} />
                                                <FormErrorContainer nameError={errors.name} />
                                            </div>

                                            <div className="col-md-6">
                                                <label>Status</label>
                                                <div className='d-flex gap-3'>
                                                    <div className='form-check mr-4'>
                                                        <Field type="radio" name="status" value="1" className='form-check-input' id="status1" />
                                                        <label htmlFor='status1' className='form-check-label'>
                                                            Active
                                                        </label>
                                                    </div>
                                                    <div className='form-check'>
                                                        <Field type="radio" name="status" value="0" className='form-check-input' id="status2" />
                                                        <label htmlFor='status2' className='form-check-label'>
                                                            Inactive
                                                        </label>
                                                    </div>
                                                    <FormErrorContainer nameError={errors.status} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='bg-grey p-3'>
                                            <div className="row">
                                                <FieldArray name="columns">
                                                    {({ push, remove }) => (
                                                        <div className='col-md-12'>
                                                            <div className='row mb-3'>
                                                                <div className='col-md-12 d-flex justify-content-between'>
                                                                    <label htmlFor="name">Template Type Columns</label>
                                                                    <button data-cy="btnAddColumn" type="button" className="btn btn-md btn-custom-secondary" onClick={() => addColumn(push)}>Add Column</button>
                                                                </div>
                                                            </div>
                                                            {values.columns.map((item: any, index: number) => (
                                                                <div className='row mb-3' key={index}>
                                                                    <div className='col-md-7'>
                                                                        <label htmlFor="name">Name<strong className='text-danger'>*</strong></label>
                                                                        <Field data-cy={`inputColumn.${index}.name`} type="text" name={`columns.${index}.name`} className='form-control' default={values.columns[index]['name']} />
                                                                        <FormErrorContainer nameError={errors && errors.columns && errors.columns[index] && errors.columns[index].name} />
                                                                    </div>
                                                                    <div className='col-md-4'>
                                                                        <label>Column Type<strong className='text-danger'>*</strong></label>
                                                                        <div className='d-flex gap-3 mt-2'>
                                                                            <div className='form-check mr-4'>
                                                                                <Field type="radio" name={`columns.${index}.columnType`} value="1" className='form-check-input' id={`columnType_stored` + index}
                                                                                />
                                                                                <label htmlFor={`columnType_stored` + index} className='form-check-label'>
                                                                                    Stored
                                                                                </label>
                                                                            </div>
                                                                            <div className='form-check'>
                                                                                <Field type="radio" name={`columns.${index}.columnType`} value="0" className='form-check-input' id={`columnType_derived` + index} />
                                                                                <label htmlFor={`columnType_derived` + index} className='form-check-label'>
                                                                                    Derived
                                                                                </label>
                                                                            </div>
                                                                            <FormErrorContainer nameError={errors && errors.columns && errors.columns[index] && errors.columns[index].columnType} />
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        values.columns.length > 1 && (
                                                                            <div className='col-md-1 margin-top-33'>
                                                                                <FontAwesomeIcon
                                                                                    icon={faTrash}
                                                                                    className="isPointer ml-2 text-danger cursor-pointer"
                                                                                    onClick={() => removeColumn(remove, index)}
                                                                                />
                                                                            </div>
                                                                        ) || <></>
                                                                    }
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </FieldArray>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="justify-content-center d-flex flex-nowrap gap-3">
                            <button type="button" className="btn btn-md revrex-outline-btn mt-3" onClick={handleClose}>
                                <span>Cancel</span>
                            </button>
                            <button data-cy="btnSubmit" type="submit" className="btn btn-md revrex-primary-btn mt-3" disabled={loading}>
                                <span>{loading && (<CircularProgress size={20} color={'success'} />) || 'Save'}</span>
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default ModalAddTemplateType;